module.exports = __webpack_public_path__ + "static/media/photo_3o3_2.6a28d101.png";